import { QuestionPlanSaleStartBeforeDate as Question } from "@/components/features/items/edit/plan/_shared/ui/components/term/sale-start-before-date";

import { usePlanSaleStartBeforeDate } from "./hooks";

export const QuestionPlanSaleStartBeforeDate = () => {
	const { saleStartBeforeDate, onSetSaleStartBeforeDate } = usePlanSaleStartBeforeDate();

	return <Question saleStartBeforeDate={saleStartBeforeDate} onSetSaleStartBeforeDate={onSetSaleStartBeforeDate} />;
};

QuestionPlanSaleStartBeforeDate.displayName = "QuestionPlanSaleStartBeforeDate";
